// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Region type.
 * @export
 * @enum {string}
 */
export enum AmazonS3AwsRegionType {
    Global = 'Global',
    UsGovernment = 'USGovernment',
    China = 'China'
}

